export default __webpack_public_path__ + "static/bubble-with-categories-1e446918a09c027e666395f02e0afdda.png";